;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import { UI_STYLE_PRIMARY_COLOR } from "../../../../../lib/constants"
import ZestLifeLogo from "../ZestLifeLogo"

// Clean skeleton for navigation bar - matches app styling
// Uses plain divs + Tailwind instead of MUI to avoid styling conflicts
function NavBarSkeleton({
  startingBackgroundSolid,
  hideProviderOnboardingBanner: _hideProviderOnboardingBanner,
}: {
  startingBackgroundSolid?: boolean
  hideProviderOnboardingBanner?: boolean
}) {
  // console.log("startingBackgroundSolid", startingBackgroundSolid)
  const positionClass = startingBackgroundSolid ? "sticky" : "fixed"
  const backgroundColor = UI_STYLE_PRIMARY_COLOR //startingBackgroundSolid
  // ? UI_STYLE_PRIMARY_COLOR
  // : "transparent"
  const backgroundGradient = UI_STYLE_PRIMARY_COLOR //startingBackgroundSolid
  // ? UI_STYLE_PRIMARY_COLOR
  // : "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)"

  return (
    <div
      className={`${positionClass} top-0 left-0 right-0 z-[1100] font-roboto`}
      style={{
        backgroundColor: backgroundColor,
        background: backgroundGradient,
        backdropFilter: "blur(10px)",
        borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="max-w-[1186px] mx-auto px-4">
        <div className="flex flex-row items-center w-full min-h-[64px]">
          <ZestLifeLogo />
          <div className="flex-1" />
          {/* Static placeholders - styled to match your buttons */}
          <div className="hidden min-[700px]:flex items-center gap-4">
            <div className="h-8 w-20 bg-white/80 rounded-full shadow-sm border border-gray-200" />
            <div className="h-8 w-20 bg-white/80 rounded-full shadow-sm border border-gray-200" />
            <div className="h-8 w-20 bg-white/80 rounded-full shadow-sm border border-gray-200" />
          </div>
          <div className="min-[700px]:hidden">
            <div className="h-8 w-8 bg-white/80 rounded-full shadow-sm border border-gray-200" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavBarSkeleton
